<template>
  <p>Order in the next 3hrs for delivery for 25th Februarry 2022.</p>
</template>
